import { Button, Stack, Tooltip } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { FormFields } from "./FormFields";
import type { FormData, ErrorState } from "../types";
import type { ReactNode } from "react";

interface EmailSignUpFormProps {
  formData: FormData;
  error: ErrorState;
  onFormDataChange: (field: keyof FormData, value: string) => void;
  onEmailBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBack?: () => void;
  onSubmit: () => void;
  queryEmail?: string;
  showUserBusinessName?: boolean;
  disableButton: boolean;
  disableButtonDueToPassword: boolean;
  effectiveBusinessSlug?: string;
  isTaxProConfirmed: boolean;
  primaryColor: string;
  submitLabel?: string;
  children?: ReactNode;
}

export const EmailSignUpForm = ({
  formData,
  error,
  onFormDataChange,
  onEmailBlur,
  onBack,
  onSubmit,
  queryEmail,
  showUserBusinessName = false,
  disableButton,
  disableButtonDueToPassword,
  effectiveBusinessSlug,
  isTaxProConfirmed,
  primaryColor,
  submitLabel = "Create Account",
  children,
}: EmailSignUpFormProps) => {
  return (
    <>
      {onBack && (
        <Button
          type="button"
          onClick={onBack}
          variant="subtle"
          size="sm"
          leftSection={<IconArrowLeft size={16} />}
          style={{
            alignSelf: "flex-start",
            marginBottom: "8px",
            color: primaryColor,
          }}
        >
          Back to sign up options
        </Button>
      )}

      <Stack className="styled-inputs" gap="md">
        <FormFields
          formData={formData}
          error={error}
          onFormDataChange={onFormDataChange}
          onEmailBlur={onEmailBlur}
          queryEmail={queryEmail}
          showUserBusinessName={showUserBusinessName}
        />
      </Stack>

      {children}

      <Tooltip
        label={
          disableButtonDueToPassword
            ? "Password requirements not met"
            : !effectiveBusinessSlug && !isTaxProConfirmed
              ? "Please confirm you are a tax professional"
              : undefined
        }
        position="top"
        withArrow
        disabled={!disableButton}
      >
        <Button
          className="create-account-sign-in"
          type="button"
          onClick={onSubmit}
          color={primaryColor}
          radius={"md"}
          size="md"
          disabled={disableButton}
          style={{
            cursor: disableButton ? "not-allowed" : "pointer",
            opacity: disableButton ? 0.5 : 1,
          }}
        >
          {submitLabel}
        </Button>
      </Tooltip>
    </>
  );
};
